const Endpoints = {
  VerifyUser: '/v1/Account/VerifyUser',
  RefeshJWT: '/v1/Account/RefeshJWT',
  VerifySuperAffiliateUser: '/v1/Affiliate/VerifySuperAffiliateUser',
  RegisterInterest: '/v1/Transaction/RegisterWaitlist',
  GetStripeIntent: '/v1/Payment/stripe/createCustomerAndSetupIntent',
  GetCards: '/v1/Payment/stripe/stripeGetCardDetails',
  DeleteCard: '/v1/Payment/stripe/stripeDeleteCard',
  LockTickets: '/v1/Transaction/LockTicketsAsync',
  SubmitTransaction: '/v1/Transaction/SubmitTransaction',
  VerifyPaystack: '/v1/Payment/payStack/transactionVerify',
  AddEnquiry: '/v1/HelpTicket/AddEnquiry',
  AppleSignedInUserUpdate: '/v1/Account/AppleSignedInUserUpdate',
  transactionVerify: '/v1/Payment/transactionVerify',
  JoinTheEventForPromotionAsync: '/v1/Promoter/JoinTheEventForPromotionAsync',
  SetPromoterCommissionOfTheEvent:
    '/v1/Promoter/SetPromoterCommissionOfTheEvent',
  ActiveDeactivePromoterAsync: '/v1/Promoter/ActiveDeactivePromoterAsync',
  ApproveRejectPromoterRequestAsync:
    '/v1/Promoter/ApproveRejectPromoterRequestAsync',
  PromoteTheEventAsync: '/v1/Promoter/PromoteTheEventAsync',
  EventsForPromotionList: '/v1/Promoter/EventsForPromotionList',
  EventListingForHost: '/v1/Promoter/EventListingForHost',
  StopPromotingTheEvent: '/v1/Promoter/StopPromotingTheEvent',
  StarPromotingTheEvent: '/v1/Promoter/StartPromotingTheEvent',
  PromoterOverview: '/v1/Promoter/PromoterOverview',
  ExistingPromotersEntryForNewEvent:
    '/v1/Promoter/ExistingPromotersEntryForNewEvent',
  UpdateInvoiceBankAccount: '/v1/Invoice/UpdateInvoiceBankAccount',
  FollowTheHostAsync: '/v1/Notification/FollowTheHostAsync',
  GetUserNotification: '/v1/Notification/GetUserNotification',
  AcknowledgeNotification: '/v1/Notification/AcknowledgeNotification',
  OnOffNotifications: '/v1/Notification/OnOffNotifications',
  GetFollowedHostList: '/v1/Notification/GetFollowedHostList',
  FollowedHostListAction: '/v1/Notification/FollowedHostListAction',
  InviteToPromoteTheEventAsync: '/v1/Promoter/InviteToPromoteTheEventAsync',
  GetUserNotificationFrequencyTypes:
    '/v1/Notification/GetUserNotificationFrequencyTypes',
  SaveSalesEmailNotificationPreference:
    '/v1/Notification/SaveSalesEmailNotificationPreference',
  PromoterRequestStatus: '/v1/Notification/PromoterRequestStatus',
  ExportTicketALLOCATION: '/v1/ExportReport/ExportTicketALLOCATION',
  DeleteEventProduct: '/v1/Transaction/DeleteEventProduct',
  SaveEventBasicDetails: '/v1/Event/SaveEventBasicDetails',
  addEventlocation: '/v1/Event/addEventlocation',
  AddEventGeneral: '/v1/Event/AddEventGeneral',
  AddEventDate: '/v1/Event/AddEventDate',
  AddEventTickets: '/v1/Event/AddEventTickets',
  AddEventSummary: '/v1/Event/AddEventSummary',
  ResetPassword: '/v1/Account/ResetPassword',
  DeleteUserEvent: '/v1/Account/DeleteUserEvent',
  InsertUserEvent: '/v1/Account/InsertUserEvent',
  UpdateUserProfile: '/v1/Account/UpdateUserProfile',
  ChangeOldPassword: '/v1/Account/ChangeOldPassword',
  AddHost: '/v1/Account/AddHost',
  AddBank: '/v1/Invoice/AddBank',
  DeleteUserBank: '/v1/Account/DeleteUserBank',
  InitiateEmailVerification: '/v1/Account/InitiateEmailVerification',
  VerifyResetPasswordToken: '/v1/Account/VerifyResetPasswordToken',
  UserRegistration: '/v1/Account/UserRegistration',
  VerifyEmail: '/v1/Account/VerifyEmail',
  GoogleAuth: '/v1/Account/GoogleAuth',
  AppleAuth: '/v1/Account/AppleAuth',
  GetFurpBankProviders: '/v1/Bank/GetBankProviders',
  FurpGetBank: '/v1/Bank/GetBanks',
  FurpGetBeneficiaryRequirement: '/v1/Bank/GetBeneficiaryRequirement',
  AddThirdPartyEventUserAsync: '/v1/Event/AddThirdPartyEventUser',
  GetSiteMaintenanceStatus: '/v1/Utility/GetSiteMaintenanceStatus',
  GetAvailableSeats: '/v1/Allocation/GetAvailableSeats',
  ConfirmChangeSeats: '/v1/Allocation/ConfirmChangeSeats',
  DeteleEventDressTerm: '/v1/Event/DeteleEventDressTerm',
  UpdateEnquiry: '/v1/HelpTicket/UpdateEnquiry',
  ReplyEnquiry: '/v1/HelpTicket/ReplyEnquiry',
  TransferTickets: '/v1/Transaction/TransferTickets',
  GetTicketToTransfer: '/v1/Transaction/GetTicketToTransfer',
  TicketToRecallReject: '/v1/Transaction/TicketToRecallReject',
  AcceptTickets: '/v1/Transaction/AcceptTickets',
  UploadImageToS3: '/v1/Utility/UploadImageToS3',
  UserRegistrationByAdmin: '/v1/Account/UserRegistrationByAdmin',
  MakePaymentAsync: '/v1/Payment/MakePaymentAsync',
  WaitlistSoldInterest: '/v1/Transaction/WaitlistSoldInterest',
  DeleteSoldOutRegisterInterest:
    '/v1/Transaction/DeleteSoldOutRegisterInterest',
  GetResellTickets: '/v2/TicketTransfer/GetResellTickets',
  ResellTickets: '/v2/TicketTransfer/ResellTickets',
  DeleteResellTickets: '/v2/TicketTransfer/DeleteResellTickets',
};

export { Endpoints };
